<ng-container *transloco="let t; prefix: 'property-upload-wizard'">
  <div class="container flex flex-1 flex-col rfs:gap-28 items-center">
    <progress-stepper class="progress-stepper-onboarding" [StepNo]="2" [Steps]="Steps"></progress-stepper>

    <div class="flex flex-col gap-12 items-center justify-center w-full">
      <div class="flex flex-col gap-4">
        <h2 class="h2 rfs:text-[40px] text-center font-semibold text-black">
          {{ t("headers.stepThree") }}
        </h2>
        <p class="rfs:text-xl text-center font-light">
          {{ t("infoText.stepThree") }}
        </p>
      </div>

      <app-google-maps-search-autocomplete-single [errorMessage]="this.mapErrorMessage" [hasError]="this.mapHasError"
        (onItemSelected)="SelectedLocation($event)"
        [defaultValue]="place?.FormatedAddress" [placeHolder]="t('placeholderText.stepThree')" [showInputLabel]="true" [inputLabel]="t('inputLabelText.stepThree')"></app-google-maps-search-autocomplete-single>

      <div class="aspect-video w-full rounded-lg border-4 border-white overflow-hidden">
        <app-map [isDraggable]="false" class="h-full w-full block" [propertySummaries$]="placeMarker.asObservable()"></app-map>
      </div>
    </div>
  </div>

  <app-property-upload-navigation [HidePrevious]="false" [NextDisabled]="!place" (NextButtonClicked)="saveStep()"
    (PreviousButtonClicked)="previousButtonClicked.emit()"></app-property-upload-navigation>
</ng-container>